<template>
  <div class="container-fluid">
    <div class="block-header position-sticky">
      <bread-crumb></bread-crumb>
    </div>
    <div class="row clearfix">
      <div class="col-md-12">
        <!-- All AllCards -->
        <AllCards></AllCards>

        <!-- All Banks Accounts -->
        <BanksAccounts></BanksAccounts>

        <!-- All MOMOAccounts -->
        <MOMOAccounts></MOMOAccounts>
      </div>
    </div>
    <main-loader :loading="isLoading"></main-loader>
  </div>
</template>
<script>
const LoaderComponent =
  require("@/components/admin/loader/LoaderComponent.vue").default;
import BanksAccounts from "./BanksAccounts.vue";
import MOMOAccounts from "./MOMOAccounts.vue";
import AllCards from "./AllCards.vue";
import { mapGetters } from "vuex";
export default {
  name: "AccountListComponent",
  components: {
    BreadCrumb: () => import("@/components/BreadCrumb.vue"),
    AllCards,
    BanksAccounts,
    MOMOAccounts,
    "main-loader": LoaderComponent,
  },
  data() {
    return {
      //
    };
  },
  methods: {
    copyText(data, type) {
      var m = document;
      data = m.createTextNode(data);
      var w = window;
      var b = m.body;
      var d = {};
      b.appendChild(data);
      d = m.createRange();
      var g = w.getSelection;
      d.selectNodeContents(data);
      g().removeAllRanges();
      g().addRange(d);
      m.execCommand("copy");
      g().removeAllRanges();
      data.remove();
      this.$toast.success(`${type} Copied`, { position: "top-right" });
    },
  },
  computed: {
    ...mapGetters(["countryList", "isLoading"]),
  },
  watch: {
    //
  },
};
</script>
